import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { IAppConfigMerchant } from '@modules/merchant/types';
import { AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS } from '@modules/affiliate-program-commissions/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import {
  AFFILIATE_PROGRAM_COMMISSIONS_MERCHANTS_LIST_QUERY_KEY,
  AFFILIATE_PROGRAM_COMMISSIONS_MERCHANTS_LIST_URL,
} from '../constants';

export default function useAffiliateProgramCommissionsMerchantsQuery(): IContextQueryResult<IAppConfigMerchant[], Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAppConfigMerchant[]>({
    queryKey: [AFFILIATE_PROGRAM_COMMISSIONS_MERCHANTS_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IAppConfigMerchant[]>(
      AFFILIATE_PROGRAM_COMMISSIONS_MERCHANTS_LIST_URL,
      {
        signal,
        permission: AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS.EDIT,
      },
    ),
  });
}
